const OFFER_STATUS_BADGE = {
  draft: 'grey',
  submitted: 'light-blue',
  old: 'orange',
  archived: 'light-red',
};

export default OFFER_STATUS_BADGE;
